import {
  Autocomplete,
  Box,
  Breadcrumbs,
  CircularProgress,
  IconButton,
  Link,
  Menu,
  MenuItem,
  Paper,
  TextField,
} from "@mui/material";
import { Container } from "react-bootstrap";
import Section from "../components/mobile screen/sections/section";

import { useEffect, useRef, useState } from "react";
import {
  generateRandomToken,
  getLocalStorageMenuItem,
  setLocalStorageMenuItem,
  setMobileBackColor,
  setMobileButttonBackColor,
  setMobileCardBorderColor,
  setMobileCardColor,
  setMobileSettings,
  setMobileTextColor,
  setMobileTextField_BK_FONT_Border_StyleColor,
} from "../utility";
import axios from "axios";
import { useNavigate, useLocation, useParams, useSearchParams } from "react-router-dom";
import Top from "../components/mobile screen/sections/Top";
import { useQuery } from "react-query";
import coverSample from "../images/No_Image_Available.jpg";
import "../css/mobileScreens.css";
import DishFullRow from "../components/mobile screen/sections/dishFullRow";
import {
  ArrowDropDownOutlined,
  ArrowLeft,
  ArrowRight,
  CloseRounded,
  TuneOutlined,
} from "@mui/icons-material";
import Toast from "../common/toast";
import SendOrderButton from "../components/mobile screen/sendOrderButton";
import i18next, { t } from "i18next";
import { InputLabel, Popper, Select } from "@mui/material";
import Loading from "../common/loading";
import FloatingChatButton from "../components/mobile screen/mobileComponents/FloatingChatButton";
import LoadingTreeDataDialog from './../components/mobile screen/mobileComponents/LoadingTreeDataDialog';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import BottomNavBar from "../components/BottomNavBar";
const Sections = ({ tableQr, tableName }) => {
  const [loadingTree, setLoadingTree] = useState(false);
  const [loading, setLoading] = useState(true);

  const [params, setParams] = useSearchParams();
  const [allTreeData, setAllTreeData] = useState(getLocalStorageMenuItem("tree_data") || [])
  const [renderKey, setRenderKey] = useState(0);
  const [loadingTreeDialog, setLoadingTreeDialog] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const checkMobilePayment = async () => {

    if (params.get("success")) {
      if (params.get("success") === "true" || params.get("success") === "1") {
        handleOpenToast(
          <div className="alignByLang">
            {t("Payemnt process done successfully")}
          </div>
          , true);

      } else {


        handleOpenToast(
          <div className="alignByLang">
            {t("Error in payment process")}
          </div>
          , false);

      }
    }
  }

  const handleActionInFloatingChatButton = (updateAction) => {
    if (updateAction) {
      setRenderKey((prevKey) => prevKey + 1);
    }

  };


  const loadTree = async () => {
    setLoadingTree(true);
    try {
      const timeZone = getLocalStorageMenuItem("timezone") || "";
      const promise = await axios.get(
        `${process.env.REACT_APP_API}/menus/${tableQr}/public-tree`,
        {
          headers: {
            localization: getLocalStorageMenuItem("lang") || "",
            timeZone: timeZone.replace(/["]+/g, ''),
          },
        }
      );
      if (promise?.data?.data?.length === 0 || !promise?.data?.data?.details || !promise?.data?.data?.tree || !promise?.data?.data?.items) {
        setLoadingTreeDialog(true);
      }
      setAllTreeData(promise?.data?.data || [])
      setLocalStorageMenuItem(
        "tree_data",
        JSON.stringify(promise?.data?.data ? promise?.data?.data : [])
      );
      setMobileSettings(promise?.data?.data?.details)
      return promise?.data?.data;
    } catch (error) {
      // Handle error
    } finally {
      setLoadingTree(false); // Hide progress dialog
    }
  }

  const loadTreeData = async () => {
    if (allTreeData.length === 0 || !allTreeData.details || !allTreeData.tree || !allTreeData.items) {
      loadTree();
    } else {
      const pathname = location.pathname;
      const pathSegments = pathname.split('/');
      const menu_code_number = pathSegments[2];
      const treeMenu_code_number = allTreeData?.details?.code_number;
      if (menu_code_number !== treeMenu_code_number) {
        loadTree();
      }
    }

  };
  const { qrName, qrCode } = useParams();
  const divRef = useRef(null);
  const [divWidth, setDivWidth] = useState(null);
  const [sectionNumber, setSectionNumber] = useState(params.get("section"));
  const [anchorEl, setAnchorEl] = useState(null);
  const [open, setOpen] = useState(false);
  const [favorites, setFavorites] = useState([]);
  const [toastSettings, setToastSettings] = useState({
    open: false,
    message: "",
    success: false,
  });

  const [currentSectionId, setCurrentSectionId] = useState(-1);
  const sectionRefs = useRef([]);

  var lang = getLocalStorageMenuItem("lang");

  useEffect(() => {
    const initializeLanguage = async () => {
      lang = getLocalStorageMenuItem("lang");

      if (!lang) {
        lang = params.get("lang");
        if (lang) {
          setLocalStorageMenuItem("lang", lang);
        } else {
          lang = 'en';
        }
      }

      // Set the language in i18next
      await i18next.changeLanguage(lang);

      // Set loading to false after language change
      setLoading(false);
    };

    initializeLanguage();
  }, [params]);

  const handleFilterClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleFilterClose = () => {
    setAnchorEl(null);
  };

  const handleClickLabel = (label_name) => {
    navigate(
      `/${qrName}/${qrCode}/labels?label_name=${label_name}&t=${params.get(
        "t"
      )}&lang=${lang}&section=${params.get("section")}`,
      { replace: true }
    );
  };



  useEffect(() => {


    loadTreeData();
    const handleScroll = () => {
      const scrollPosition = window.scrollY + 140;
      sectionRefs.current.forEach((ref, index) => {
        if (ref && ref.offsetTop <= scrollPosition) {
          setCurrentSectionId(index);
        }
      });
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const updateTreeData = (newTreeData) => {
    setAllTreeData(newTreeData)
  }

  const handleSectionClick = (index) => {
    const section = sectionRefs.current[index];
    if (section) {
      window.scrollTo({
        top: section.offsetTop - 140,
        behavior: "smooth",
      });
    }
    setCurrentSectionId(index);
  };

  const handleSectionClickWithBack = async (index) => {
    params.set('section', 0);
    setCurrentSectionId(index)
    await setParams(params);
    setTimeout(() => {
      const section = sectionRefs.current[index];

      console.log("sections :: ", sectionRefs.current)
      console.log("index is ", index)
      console.log("section is ", section)
      if (section) {
        window.scrollTo({
          top: section.offsetTop - 140,
          behavior: "smooth",
        });
      }
      setCurrentSectionId(index);
    }, 500);

  };

  const handleBreadcrumbSectionClick = async (index, sectionId) => {

    const breadcrumbsLength = data?.data?.data?.details?.breadcrumbs?.length || 0;
    if (index === breadcrumbsLength - 1) {
      return true
    }
    params.set('section', 0);
    await setParams(params);
    setTimeout(() => {
      const section = sectionRefs.current[sectionId];
      if (section) {
        window.scrollTo({
          top: section.offsetTop - 140,
          behavior: "smooth",
        });
      }
      setCurrentSectionId(sectionId);
    }, 500);

  };



  const fetchFun = () => {

    if (params.get("section") !== "0" && params.get("section") !== "null") {
      return axios.get(
        `${process.env.REACT_APP_API
        }/menus/${qrCode}/public-section?section_id=${params.get("section") || 0}`,
        { headers: { localization: getLocalStorageMenuItem("lang") } }
      );
    } else {
      return axios.get(
        `${process.env.REACT_APP_API}/menus/${qrCode}/public-section?section_id`,
        { headers: { localization: getLocalStorageMenuItem("lang") } }
      );
    }
  };

  const { data, isLoading, isFetching, isError, isPreviousData } = useQuery(
    ["mainSections", sectionNumber, getLocalStorageMenuItem("lang")],
    fetchFun
  );

  const {
    data: itemsData,
    isLoading: itemsIsLoading,
    isFetching: itemsIsFetching,
    isError: ItemsIsError,
    error: itemsError,
    refetch: itemsRefetch,
  } = useQuery("items", () => {
    try {
      return axios.get(
        `${process.env.REACT_APP_API}/menus/${qrCode}/public-search`,
        { headers: { localization: getLocalStorageMenuItem("lang") } }
      );
    } catch (error) {
      console.error("Error fetching items:", error);
      return [];
    }
  });

  const handleItem = (event, value) => {
    if (value.id) {
      navigate(`/${qrName}/${qrCode}/items?item=${value.id}&selectedLang=${getLocalStorageMenuItem("lang")}`);
    }
  };

  const handleLanguage = async (lang) => {
    i18next.changeLanguage(lang);
    document.querySelector("html").lang = lang;
    setLocalStorageMenuItem("lang", lang);
    params.set("lang", lang);
    if (lang === "ar" || lang === "fa") {
      document.body.classList.remove("latino-font");
      document.body.classList.add("arabic-font");
    } else {
      document.body.classList.add("latino-font");
      document.body.classList.remove("arabic-font");
    }
    setParams(params);
  };


  const handleParentSection = (section) => {
    if (section.parent_id) {
      if (section.id) {
        setSectionNumber(section.id);
        params.set("section", section.id || 0);
        setParams(params);
      } else {
        setSectionNumber(0);
        params.set("section", 0);
        setParams(params);
      }
    } else {
      setSectionNumber(0);
      params.set("section", 0);
      setParams(params);
    }
    window.scrollTo(0, 0);
  };

  const handleSectionScroll = (el, index) => {
    sectionRefs.current[index] = el;
  }

  const handleParent = () => {
    if (data?.data?.data?.details.parent_id) {
      setSectionNumber(data?.data?.data?.details.parent_id);
      params.set("section", data?.data?.data?.details.parent_id || 0);
    } else {
      setSectionNumber(0);
      params.set("section", 0);
    }
    setParams(params);
  };

  const backToMain = () => {
    setSectionNumber(0);
    params.set("section", 0);
    setParams(params);
  };

  const onImageError = (e) => {
    e.target.src = coverSample;
  };

  const handleFavorite = (item) => {

    const index = favorites.findIndex((fav) => fav.id === item.id);
    if (index === -1) {
      const newFavorites = [...favorites, item];
      setFavorites(newFavorites);
      setLocalStorageMenuItem("favorites", JSON.stringify(newFavorites));
      handleOpenToast(t("Added to favorites"));
    } else {
      const newFavorites = favorites.filter(
        (favItem) => favItem.id !== item.id
      );
      setFavorites(newFavorites);
      setLocalStorageMenuItem("favorites", JSON.stringify(newFavorites));
      handleOpenToast(t("Removed from favorites"));
    }
  };

  const { data: favoritesData, isLoading: favoritesIsLoading } = useQuery(
    "favorites",
    async () => {
      const favoritesFromCookie = getLocalStorageMenuItem("favorites");
      if (favoritesFromCookie) {
        const favoritesItems = JSON.parse(favoritesFromCookie);
        const favoritesArray = favoritesItems?.map((item) => item.id);
        const promise = await axios.get(
          `${process.env.REACT_APP_API
          }/menus/${qrCode}/favourites?items=${JSON.stringify(favoritesArray)}`,
          { headers: { localization: lang } }
        );
        setFavorites(JSON.parse(favoritesFromCookie));
        return promise;
      }
      setFavorites([]);
      return [];
    }
  );




  useEffect(() => {
    if (divRef.current) {
      const width = divRef.current.offsetWidth;
      setDivWidth(width);
    }
  });

  const handleOpenToast = (message) => {
    const toast = { ...toastSettings };
    toast.open = true;
    toast.success = true;
    toast.message = message;
    setToastSettings(toast);
  };

  const handleCloseToast = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setToastSettings({ open: false, message: "", success: false });
  };

  useEffect(() => {
    checkMobilePayment();

    if (!getLocalStorageMenuItem("gustToken")) {
      setLocalStorageMenuItem("gustToken", generateRandomToken(25));
    }

    document.body.style.direction = "ltr";
  }, []);

  function CustomPopper(props) {
    return <Popper {...props} placement="top-start" disablePortal={true} />;
  }

  if (loading || loadingTree) {
    return <Loading backColor={setMobileBackColor()} />; // Can show a loader here
  }

  return (
    <div
      className={`min-vh-100`}
      style={{ backgroundColor: setMobileBackColor() }}
    >

      <Container fluid>
        <div className="row">
          <div className="col-lg-8 d-none d-xl-block">
            <div className="text-center d-flex-justify-content-center align-items-center">
              <div style={{ marginTop: "15%", left: "25%", position: "fixed" }}>
                <img
                  src={allTreeData?.details?.logo}
                  className="me-4 slider-mobile-logo"
                  style={{ width: "250px", height: "250px" }}
                  onError={onImageError}
                />
                <h1
                  className="mt-4 head-font"
                  style={{ color: setMobileTextColor() }}
                >
                  {allTreeData?.details?.venu_name}
                </h1>
              </div>
            </div>
          </div>
          <div className="col-lg-4 p-0 m-0 ms-auto">
            <div
              className="mobile-side-screen"
              style={{ marginBottom: "50px" }}
              ref={divRef}
            >

              {params.get("section") != 0 ?
                // <Top
                //   order_ability={allTreeData?.details?.order_ability || false}
                //   currentId={params.get("section")}
                //   parentId={data?.data?.data?.details?.parent_id}
                //   mianSectionsData={{ sections: allTreeData }}
                //   qrCode={qrCode}
                //   qrName={qrName}
                //   handleLanguage={handleLanguage}
                //   updateTreeData={(newtree) => updateTreeData(newtree)}
                //   handleParentSection={handleParentSection}
                //   detailsData={allTreeData?.details}
                //   lablesData={allTreeData?.labels}
                //   handleParent={handleParent}
                //   backToMain={backToMain}
                //   width={divWidth}
                //   label_name={null}
                //   itemsRefetch={itemsRefetch}
                // />

                <Top
                  order_ability={allTreeData?.details?.order_ability || false}
                  currentId={params.get("section")}
                  currentSectionId={currentSectionId}
                  parentId={data?.data?.data?.details?.parent_id}
                  mianSectionsData={{ tree: allTreeData }}
                  qrCode={qrCode}
                  qrName={qrName}
                  handleLanguage={handleLanguage}
                  updateTreeData={(newtree) => updateTreeData(newtree)}

                  handleOnClick={(index) => handleSectionClickWithBack(index)}
                  detailsData={allTreeData?.details}
                  lablesData={allTreeData?.labels}
                  label_name={null}
                  handleParent={handleParent}
                  backToMain={backToMain}
                  width={divWidth}
                  itemsRefetch={itemsRefetch}
                />
                :
                <Top
                  order_ability={allTreeData?.details?.order_ability || false}
                  currentId={params.get("section")}
                  currentSectionId={currentSectionId}
                  parentId={data?.data?.data?.details?.parent_id}
                  mianSectionsData={{ tree: allTreeData }}
                  qrCode={qrCode}
                  qrName={qrName}
                  handleLanguage={handleLanguage}
                  updateTreeData={(newtree) => updateTreeData(newtree)}

                  handleOnClick={(index) => handleSectionClick(index)}
                  detailsData={allTreeData?.details}
                  lablesData={allTreeData?.labels}
                  label_name={null}
                  handleParent={handleParent}
                  backToMain={backToMain}
                  width={divWidth}
                  itemsRefetch={itemsRefetch}
                />
              }

              <div className="sections">
                <div className="sections-content">
                  <div className="alignByLang" style={{ display: "flex", alignItems: "center" }}>
                    <IconButton
                      aria-label="filter"
                      onClick={handleFilterClick}
                      style={getLocalStorageMenuItem("lang") === "ar" ||
                        getLocalStorageMenuItem("lang") === "fa" ? { marginRight: "8px" } : { marginLeft: "8px" }}
                    >
                      <TuneOutlined sx={{ color: setMobileTextColor() }} />
                    </IconButton>
                    <Menu
                      anchorEl={anchorEl}
                      open={Boolean(anchorEl)}
                      onClose={handleFilterClose}
                      sx={{
                        '& .MuiPaper-root': {
                          backgroundColor: setMobileCardColor(),
                          width: '100%',
                          textAlign: "center"
                        },
                      }}
                      style={{ textAlign: "center" }}
                    >
                      {allTreeData?.labels?.map((label, index) =>
                        label.count > 0 ? (
                          <MenuItem
                            key={index}
                            sx={{
                              textAlign: "center",
                              backgroundColor: setMobileCardColor(),
                              color: setMobileTextColor(),
                              justifyContent: "center",
                              width: "100%",
                              '&:hover': {
                                backgroundColor: setMobileBackColor(),
                              },
                              fontFamily:
                                getLocalStorageMenuItem("lang") === "ar" ||
                                  getLocalStorageMenuItem("lang") === "fa"
                                  ? "Almarai"
                                  : "Roboto",
                            }}
                            style={{ textAlign: "center" }}

                            onClick={() => handleClickLabel(label.name)}
                          >
                            {t(label.name)}
                          </MenuItem>
                        ) : null
                      )}
                    </Menu>

                    <Autocomplete
                      className={`w-100 rounded-2 MuiInputBase-root sub-font`}
                      id="asynchronous-demo"
                      style={{
                        borderWidth: 1,
                        borderStyle: "solid",
                        backgroundColor: setMobileTextField_BK_FONT_Border_StyleColor()[0],
                        color: setMobileTextField_BK_FONT_Border_StyleColor()[1],
                        borderColor: setMobileTextField_BK_FONT_Border_StyleColor()[2],
                        borderRadius: "8px",
                        height: "44px",
                        fontSize: "16px",
                        fontWeight: 400,
                      }}
                      sx={{
                        "& .MuiInputBase-root": {
                          color: setMobileTextField_BK_FONT_Border_StyleColor()[1],
                        },
                        "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
                          borderColor: setMobileCardBorderColor(),
                        },
                      }}
                      placeholder="Search for menu"
                      PaperComponent={(props) => (
                        <Paper
                          className="sub-font"
                          sx={{
                            backgroundColor: setMobileBackColor(),
                            color: setMobileTextColor(),
                            fontSize: "14px",
                            "& .MuiAutocomplete-noOptions": {
                              backgroundColor: setMobileCardColor(),
                              color: setMobileTextColor(),
                            },

                            "& .MuiAutocomplete-option": {
                              backgroundColor: setMobileCardColor(),
                              color: setMobileTextColor(),
                              fontFamily:
                                getLocalStorageMenuItem("lang") === "ar" ||
                                  getLocalStorageMenuItem("lang") === "fa"
                                  ? "Almarai"
                                  : "Roboto",
                            },

                          }}
                          {...props}
                        />
                      )}
                      clearIcon={<CloseRounded sx={{ color: setMobileTextColor() }} />}
                      popupIcon={<ArrowDropDownOutlined sx={{ color: setMobileTextColor() }} />}
                      open={open}
                      onOpen={() => {
                        !itemsIsLoading && setOpen(true);
                      }}
                      onClose={() => {
                        setOpen(false);
                      }}
                      isOptionEqualToValue={(option, value) => option.title === value.label}
                      onChange={handleItem}
                      getOptionLabel={(option) => option.label}
                      options={itemsData?.data?.map((item) => {
                        return { id: item.id, label: item.name };
                      })}
                      loading={itemsIsLoading}
                      size="small"
                      renderInput={(params) => (
                        <div style={{ display: "flex", alignItems: "center" }}>
                          <TextField
                            className="alignByLang sub-font"
                            placeholder={t("Search....")}
                            {...params}
                            inputProps={{
                              ...params.inputProps,
                              onFocus: (e) => {
                                // Prevent automatic scrolling when keyboard opens
                                e.preventDefault();
                                setTimeout(() => {
                                  window.scrollTo(0, 0);
                                  document.body.scrollTop = 0;
                                }, 100);
                              },
                              endAdornment: (
                                <>
                                  {itemsIsLoading ? <CircularProgress color="inherit" size={20} /> : null}
                                  {params.inputProps.endAdornment}
                                </>
                              ),
                            }}

                            sx={{
                              "input::placeholder": {
                                fontFamily:
                                  getLocalStorageMenuItem("lang") === "ar" ||
                                    getLocalStorageMenuItem("lang") === "fa"
                                    ? "Almarai"
                                    : "Roboto",
                              },
                              "& input": {
                                fontFamily:
                                  getLocalStorageMenuItem("lang") === "ar" ||
                                    getLocalStorageMenuItem("lang") === "fa"
                                    ? "Almarai"
                                    : "Roboto",
                              },
                            }}
                          />
                        </div>
                      )}
                      PopperComponent={CustomPopper}
                    />

                  </div>
                  {data && data?.data?.data?.details.breadcrumbs && (
                    <div className="ps-2 pe-2 m-top-12 mb-2 fw-bold head-font alignByLang">
                      <Breadcrumbs
                        separator={
                          getLocalStorageMenuItem("lang") === "ar" ||
                            getLocalStorageMenuItem("lang") === "fa" ? (
                            <ArrowLeft
                              className={`cursor`}
                              style={{ color: setMobileTextColor() }}
                            />
                          ) : (
                            <ArrowRight
                              className={`cursor`}
                              style={{ color: setMobileTextColor() }}
                            />
                          )
                        }
                      >
                        {data?.data?.data?.details?.breadcrumbs?.map(
                          (section, index) => (
                            <Link
                              key={section.id}
                              className="meta-path"
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                textDecoration: "none",
                              }}
                              color="inherit"
                              onClick={() => handleBreadcrumbSectionClick(index, currentSectionId)}
                            >
                              {index ===
                                data?.data?.data?.details.breadcrumbs.length -
                                1 &&
                                data?.data?.data?.details.breadcrumbs.length > 1 ? (
                                <strong
                                  className="sub-font cursor"
                                  style={{
                                    textDecoration: "none",
                                    color: setMobileButttonBackColor(),
                                  }}
                                >
                                  {t(section.name)}
                                </strong>
                              ) : (
                                <strong
                                  className="sub-font cursor"
                                  style={{
                                    textDecoration: "none",
                                    color: setMobileTextColor(),
                                  }}
                                >
                                  {t(section.name)}
                                </strong>
                              )}
                            </Link>
                          )
                        )}
                      </Breadcrumbs>
                    </div>
                  )}

                  {params.get("section") != 0 ? isLoading ? (
                    <Box
                      className={`vh-100 w-100 h-100`}
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        backgroundColor: setMobileCardColor(),
                      }}
                    >
                      <CircularProgress sx={{ marginBottom: 25 }} />
                    </Box>
                  ) : (
                    <div className="mb-3 alignByLang">
                      <div className="row">
                        {data?.data?.data?.sections?.map(
                          (section, index) =>
                            section.active && (
                              <Section
                                key={section.id}
                                section={section}
                                handleSectionScroll={(el) => handleSectionScroll(el, index)}
                                handleParentSection={handleParentSection}
                                disabledFlag={0}
                              />

                            )
                        )}
                      </div>

                      <div className="row">
                        {data?.data?.data?.items?.map(
                          (item) =>
                            item.active &&
                            (getLocalStorageMenuItem("showOption") ===
                              "twoItem" ? (
                              <DishFullRow
                                in_root={false}
                                key={item.id}
                                item={item}
                                qrCode={qrCode}
                                qrName={qrName}
                                sympole={allTreeData?.details?.currency_symbol ? allTreeData?.details?.currency_symbol : ""}
                                handleFavorite={handleFavorite}
                                favorites={favorites}
                                suggested={false}
                              />
                            ) : (
                              <DishFullRow
                                in_root={false}
                                key={item.id}
                                item={item}
                                qrCode={qrCode}
                                qrName={qrName}
                                sympole={allTreeData?.details?.currency_symbol ? allTreeData?.details?.currency_symbol : ""}
                                handleFavorite={handleFavorite}
                                favorites={favorites}
                                suggested={false}
                              />
                            ))
                        )}

                      </div>
                    </div>
                  ) : (
                    <div className="mb-3 alignByLang">
                      <div className="row">
                        {allTreeData?.tree && Object.values(allTreeData?.tree).map((section, index) => (

                          <>
                            {
                              section.active && (
                                <Section
                                  key={section.id}
                                  section={section}
                                  handleParentSection={handleParentSection}
                                  handleSectionScroll={(el) => handleSectionScroll(el, index)}
                                  disabledFlag={1}
                                />
                              )
                            }

                            {

                              Array.isArray(section?.children?.sections) &&
                              section?.children?.sections?.length > 0 && (
                                Object.values(section?.children?.sections).map((sectionItem, index) => (
                                  sectionItem.active && (
                                    <Section
                                      key={sectionItem.id}
                                      section={sectionItem}
                                      parentSectionName={section.name}
                                      handleSectionScroll={(el) => handleSectionScroll(el, index)}
                                      handleParentSection={handleParentSection}
                                      disabledFlag={0}
                                    />


                                  )
                                ))
                              )
                            }
                            {section?.children?.items?.map(
                              (item) =>
                                item.active &&
                                (getLocalStorageMenuItem("showOption") ===
                                  "twoItem" ? (
                                  <DishFullRow
                                    in_root={true}
                                    key={item.id}
                                    item={item}
                                    qrCode={qrCode}
                                    qrName={qrName}
                                    sympole={allTreeData?.details?.currency_symbol ? allTreeData?.details?.currency_symbol : ""}
                                    handleFavorite={handleFavorite}
                                    favorites={favorites}
                                    suggested={false}
                                  />
                                ) : (
                                  <DishFullRow
                                    in_root={true}
                                    key={item.id}
                                    item={item}
                                    qrCode={qrCode}
                                    qrName={qrName}
                                    sympole={allTreeData?.details?.currency_symbol ? allTreeData?.details?.currency_symbol : ""}
                                    handleFavorite={handleFavorite}
                                    favorites={favorites}
                                    suggested={false}
                                    scrollPosition={window.screenY}
                                  />
                                ))
                            )}
                          </>
                        ))}
                        <div style={{
                          height: !allTreeData?.details?.order_ability &&
                            !allTreeData?.details?.whatsapp ? "0px" : "50px"
                        }}>

                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>

            </div>
          </div>
        </div>
        <Toast
          open={toastSettings.open}
          message={toastSettings.message}
          resetToast={handleCloseToast}
          success={toastSettings.success}
        />
        <FloatingChatButton qrCode={qrCode}
          qrName={qrName}
          sympole={allTreeData?.details?.currency_symbol ? allTreeData?.details?.currency_symbol : ""}
          handleFavorite={handleFavorite}
          favorites={favorites}
          suggested={false}
          onActionDone={handleActionInFloatingChatButton}
          treeData={allTreeData}
        />
        <LoadingTreeDataDialog openTreeDialogFlag={loadingTreeDialog} tableName={tableName} tableQr={tableQr} />
      </Container>
      <BottomNavBar qr={tableQr} qrName={tableName} />

    </div>
  );
};

export default Sections;
